var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sub-navbar"},_vm._l(((_vm.menu.children || []).filter(item => item.display == 1)),function(item){return _c('div',{key:item.id,staticClass:"nav-item"},[_c('div',{staticClass:"first-child pointer",on:{"click":function($event){return _vm.handleClick(item)}}},[_c('div',{staticClass:"name"},[_vm._v(_vm._s(item.name))])])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }